import type {ButtonProps} from '@/components/base/Button';

export enum NotificationType {
  SUCCESS = 'Success',
  ERROR = 'Error',
  WARNING = 'Warning',
}
interface INotification {
  id?: string;
  type: NotificationType;
  msg: string | JSX.Element;
  disableAuto?: boolean;
  actions?: (ButtonProps & {label: string})[];
  subMsg?: string;
  onClose?: () => void;
}
export default INotification;
